import { zIndexMouseCatcher } from 'crazyEditor/core/globals';

export default {
  mouseCatcherContainer: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    zIndex: zIndexMouseCatcher,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'cubic-bezier(0.08, 0.59, 0.35, 1.01)',
    transitionDuration: '250ms',
  }
};
